/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import EnvUtil from '../env-util';

/**
 * Tovární metoda na zaznamenávače výjimek.
 * @param {string} [buildId] Identifikátor sestavení.
 * @param {ConsoleLoggerFactory} consoleFactory
 * @param {string} env `NODE_ENV` prostředí aplikace
 * @param {string} [sentryDsn] Sentry DSN adresa k odesílání záznamů.
 * @param {SentryLoggerFactory} sentryFactory
 * @returns {Logger}
 */
function LoggerFactory(buildId, consoleFactory, env, sentryDsn, sentryFactory) {
  /**
   * @returns {Logger}
   */
  function createLogger() {
    if (isNil(sentryDsn)) {
      return consoleFactory.create();
    }
    return sentryFactory.create(sentryDsn);
  }

  const logger = createLogger();
  logger.setInfo({ buildId, envEnum: EnvUtil.parse(env) });
  return logger;
}

export default LoggerFactory;
